<template>
  <div class="option-module">
    <div>
      <textarea v-model="text" placeholder="请输入150字之内的意见" maxlength="150" cols="30" rows="10"></textarea>
    </div>
    <div class="submit" @click="submit">
      提交反馈
    </div>
  </div>
</template>
<style lang="scss" rel="stylesheet/scss">
  @import '../../../src/assets/css/basic';

  .option-module {
    height: 100%;
    padding: p2r(20);
    textarea {
      display: block;
      position: relative;
      padding: p2r(20);
      font-size: p2r(16);
      width: 100%;
      outline: none;
      border:1px solid transparent; /*no*/
      resize: none;
    }
    .submit {
      background: url("img/button.png") center top no-repeat;
      background-size: 100% 100%;
      margin: p2r(26) auto;
      width: p2r(180);
      height: p2r(50);
      line-height: p2r(50);
      text-align: center;
      color: white;
      font-size: p2r(15);
    }
  }
</style>
<script>
  export default{
    data(){
      return {
        text: ''
      }
    },
    created(){
      document.title = '意见反馈'
    },
    components: {},
    methods: {
      submit () {
        console.log(this.text)
      }
    }
  }
</script>
